import React from 'react';

function DefaultImage() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16">
      <path fill="currentColor" fillOpacity=".6" fillRule="evenodd" d="M20.045 13.5c0 .827-.642 1.5-1.431 1.5H2.386c-.789 0-1.431-.673-1.431-1.5v-11c0-.827.642-1.5 1.431-1.5h16.228c.789 0 1.431.673 1.431 1.5v11zM12.56 8.417L9.282 5.14a.514.514 0 0 0-.707 0L4.146 9.57a.5.5 0 0 0 .707.707l4.075-4.076 4.082 4.083a.502.502 0 0 0 .708 0 .502.502 0 0 0 0-.708l-.452-.452 1.136-1.035 2.164 2.186a.499.499 0 1 0 .71-.704l-2.501-2.527a.5.5 0 0 0-.692-.017l-1.524 1.39zM18.614 0C19.93 0 21 1.121 21 2.5v11c0 1.379-1.07 2.5-2.386 2.5H2.386C1.07 16 0 14.879 0 13.5v-11C0 1.121 1.07 0 2.386 0h16.228z" />
    </svg>
  );
}

export default DefaultImage;
